// Sticky bar appears after hero is scrolled past
    const hero = document.getElementById('product');
    const stickyBar = document.getElementById('stickyBar');
    if (hero && stickyBar) {
      const io1 = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('show');
          } else {
            stickyBar.classList.remove('show');
          }
        });
      }, { threshold: 0 });
      io1.observe(hero);
    }

    // Reveal-on-scroll for sections
    const reveals = document.querySelectorAll('.reveal');
    const io2 = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io2.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(el => io2.observe(el));